import { useContext } from 'react';
import {
  TokenAssetsContext,
  TokenAssetsContextValue,
} from '@providers/TokenAssetsProvider';

function useTokenAssetsContext(): TokenAssetsContextValue {
  return useContext(TokenAssetsContext);
}

export default useTokenAssetsContext;
